import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.95, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ label, title, sub, align = "left" }) => (
  <div className={align === "center" ? "text-center" : "text-left"}>
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold">
        {label}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-5 font-display text-4xl font-light tracking-tight text-[#F5F5F5] md:text-5xl lg:text-6xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p
          className={`mt-6 max-w-2xl text-base leading-relaxed text-[#A3A3A3] md:text-lg ${
            align === "center" ? "mx-auto" : ""
          }`}
        >
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);

export { EASE };
